import { observable, action, runInAction } from 'mobx'
import Api from '@api/yun_xuan/potentialCustomersApi'
import { message, Modal } from 'hljd'
import { hashHistory } from 'react-router'
import { isObj } from '@hlj/hlj-utils'
class Store {
  modeOptions = [
    { label: '私信', value: '1', cls: 'chat' },
    { label: '活动弹窗', value: '2', disabled: true, cls: 'activity' },
    { label: '短信', value: '3', disabled: true, cls: 'sms' }
  ]
  limitCount = 300
  @observable title = '未命名'
  @observable activePanel = 'range'
  @observable userRange = []
  @observable userRangeTxt = []
  @observable sendMode = ['1']
  @observable sendModeTxt = ['私信']
  @observable content = ''
  @observable score = 0
  @observable originalList = []
  @observable options = []
  @observable checkedList = []
  @observable checkAll = true
  @observable selectedRowKeys = []
  @observable actionList = []
  @observable limit = 300
  @observable
  pagination = {
    current: 1,
    pageSize: 300,
    total: 0
  }
  @observable loading = false
  getActionList = async () => {
    const { success, data } = await Api.getActionList()
    if (success) {
      this.actionList = data || []
      this.options = (data || []).map(item => ({
        label: `${item.action_title}(${item.action_count})`,
        value: item.action_name
      }))
      this.userRangeTxt = this.actionList.map(item => item.action_title)
    }
  }
  @action
  getCustomerList = async (isAutoChecked, page = 1) => {
    this.loading = true
    const { success, data } = await Api.getCustomerList({
      page,
      per_page: this.pagination.pageSize,
      action_name: this.checkedList.join(',')
    })
    const { list, score, total_count } = data || {}
    runInAction(() => {
      if (success) {
        this.pagination.total = +total_count
        this.score = +score
        this.userRange = list || []
        this.limit = this.score > this.limitCount ? this.limitCount : this.score
        if (isAutoChecked) {
          this.selectedRowKeys = this.userRange
            .map(item => item.id)
            .slice(0, this.limit)
        }
      }
      this.loading = false
    })
  }
  @action
  changePanel = key => {
    const { activePanel } = this
    const msg = activePanel ? this.validator(activePanel) : 'pass'
    if (msg != 'pass') {
      return message.warning(msg)
    }
    this.activePanel = key
  }
  @action
  changeField = type => e => {
    this[type] = isObj(e) ? e.target.value : e
    type == 'content' && this.checkContent()
  }

  @action
  changeSendMode = checkedValues => {
    this.sendMode = checkedValues
    this.sendModeTxt = this.modeOptions
      .filter(item => checkedValues.includes(item.value))
      .map(item => item.label)
  }

  @action
  saveParams = type => e => {
    e.stopPropagation()
    const msg = this.validator(type)
    if (msg != 'pass') {
      return message.warning(msg)
    }
    this.activePanel = ''
  }
  @action
  onChange = checkedList => {
    this.checkedList = checkedList
    this.checkAll = !checkedList.length
    this.getCustomerList(true, 1)
    if (this.checkAll) {
      this.userRangeTxt = this.actionList.map(item => item.action_title)
    } else {
      this.userRangeTxt = this.actionList
        .filter(item => checkedList.includes(item.action_name))
        .map(item => item.action_title)
    }
    this.selectedRowKeys = this.userRange
      .map(item => item.id)
      .slice(0, this.limit)
  }
  @action
  onCheckAllChange = e => {
    this.checkedList = []
    this.userRangeTxt = []
    this.checkAll = e.target.checked
    if (this.checkAll) {
      this.userRangeTxt = this.actionList.map(item => item.action_title)
      this.selectedRowKeys = this.userRange
        .map(item => item.id)
        .slice(0, this.limit)
    }
  }
  @action
  onSelectChange = keys => {
    this.selectedRowKeys = keys.slice(0, this.limit)
  }
  @action
  onSelectAll = selected => {
    if (selected) {
      this.selectedRowKeys = [
        ...this.selectedRowKeys,
        ...this.userRange.map(item => item.id)
      ].slice(0, this.limit)
    } else {
      this.selectedRowKeys = []
    }
  }
  @action
  validator = type => {
    const { title, selectedRowKeys, sendMode, content } = this
    if (type == 'range') {
      if (!selectedRowKeys.length) {
        return '人员范围不能为空'
      }
    } else if (type == 'sendMode') {
      if (!sendMode.length) {
        return '发送方式不能为空'
      }
    } else if (type == 'content') {
      if (!content.trim()) {
        return '详细内容不能为空'
      }
      if (content == 'Hi  {婚礼纪用户名}') {
        return '请补充详细内容'
      }
    } else {
      if (!title.trim()) {
        return '标题不能为空'
      }
    }
    return 'pass'
  }
  @action
  pushCustomer = async () => {
    const {
      selectedRowKeys,
      userRangeTxt,
      title,
      content,
      sendMode,
      activePanel
    } = this
    const _msg = this.validator()
    if (activePanel) {
      return message.warning('请完善推送信息')
    }
    if (_msg != 'pass') {
      return message.warning(_msg)
    }
    Modal.confirm({
      title: `确认发送推送 ${title}？`,
      content: '发送之后，将无法撤回。请仔细检查信息后再确认发送。',
      onOk: async () => {
        const { success } = await Api.pushCustomer({
          id: selectedRowKeys.join(','),
          customer_group: userRangeTxt.join('+'),
          type: sendMode.join(','),
          title,
          content
        })
        if (success) {
          this.reset()
          hashHistory.push('/localMerchant/potentialCustomers')
        }
      }
    })
  }
  @action
  reset = () => {
    this.title = '未命名'
    this.activePanel = 'range'
    this.userRange = []
    this.userRangeTxt = []
    this.sendMode = []
    this.sendModeTxt = []
    this.content = ''
    this.checkedList = []
    this.checkAll = true
    this.selectedRowKeys = []
  }
  @action
  initContent = () => {
    if (!this.content) {
      this.content = 'Hi  {婚礼纪用户名}'
    }
  }
  @action
  checkContent = () => {
    const variables = [
      '{婚礼纪用户名',
      '{婚礼纪用户',
      '{婚礼纪用',
      '{婚礼纪',
      '{婚礼',
      '{婚',
      '{'
    ]
    if (this.content.indexOf('{婚礼纪用户名}') == -1) {
      variables.forEach(item => {
        if (this.content.indexOf(item) > -1)
          this.content = this.content.replace(new RegExp(item, 'g'), '')
      })
    }
  }
  @action
  paginationChange = ({ current }) => {
    this.pagination.current = current
    this.getCustomerList(false, current)
  }
}

export default Store
